import { cn, SkeletonCircle, SkeletonRectangle } from '@kiiwi/ui';
import React from 'react';
import useResponsive from '@/src/hooks/useResponsive';

const ProCardSkeleton = () => {
  const { isMobile } = useResponsive();

  return (
    <div
      className={cn(
        'relative flex w-[inherit] flex-1 gap-4 rounded-lg border border-neutral bg-surface-white p-3 text-neutral-primary',
        isMobile && 'flex-col',
      )}
    >
      <div className={cn('h-max', isMobile ? 'hidden' : 'block')}>
        <SkeletonCircle className="size-[72px]" />
      </div>
      <div className="flex flex-1 flex-col gap-3 overflow-hidden">
        <div className="flex gap-2 overflow-hidden">
          <div className={cn('flex-shrink-0', isMobile ? 'block' : 'hidden')}>
            <SkeletonCircle className="size-10" />
          </div>
          <div
            className={cn(
              'flex flex-1 flex-col gap-1 overflow-hidden',
              isMobile ? 'h-11' : 'h-13',
            )}
          >
            <SkeletonRectangle className="w-40 flex-1" />
            <SkeletonRectangle className="w-52 flex-1" />
          </div>
        </div>

        <div className={cn('flex flex-col gap-1', isMobile ? 'h-10' : 'h-12')}>
          <SkeletonRectangle className="w-64 flex-1" />
          <SkeletonRectangle className="w-48 flex-1" />
        </div>
      </div>

      <div className={cn(isMobile ? 'w-full' : 'w-[330px]')}>
        <SkeletonRectangle
          className={cn(isMobile ? 'h-[150px]' : 'h-[170px]')}
        />
      </div>
    </div>
  );
};

export default ProCardSkeleton;
